import React , {Component}  from 'react'
import {Switch, Route, BrowserRouter} from 'react-router-dom';

import './Common.scss';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-grid.css';
import 'bootstrap/dist/css/bootstrap-reboot.css';

import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all';

// self
import WebRouter from './Web/WebRouter'
import ErrorPage from './ErrorPage'

export default class MyRouter extends Component
{
    componentDidMount()
    {
        console.log("componentDidMount");
    }

    render()
    {
        return(
            <BrowserRouter>
                <Switch>
                    <Route path="/" component={WebRouter}/>
                    <Route component={ErrorPage}></Route>
                </Switch>
            </BrowserRouter>
        );
    }
}